import { graphql } from "relay-runtime"

const PatientBodyMeasurementsOutputFragment = graphql`
  fragment PatientBodyMeasurementsOutputFragment on BodyMeasurementsEdge @relay(plural: true) {
    node {
      id
      date
      height
      weight
      bodyMassIndex
    }
  }
`

const PatientBodyMeasurementsOutputFragmentInline = graphql`
  fragment PatientBodyMeasurementsOutputFragmentInline on BodyMeasurementsEdge @inline @relay(plural: true) {
    node {
      id
      date
      height
      weight
      bodyMassIndex
    }
  }
`

export { PatientBodyMeasurementsOutputFragment, PatientBodyMeasurementsOutputFragmentInline }
